/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferentialDto
 */
export interface ReferentialDto {
    /**
     * 
     * @type {string}
     * @memberof ReferentialDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferentialDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ReferentialDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ReferentialDto
     */
    iconKey?: string;
    /**
     * Hex color code (e.g.
     * @type {string}
     * @memberof ReferentialDto
     */
    color?: string | null;
}

/**
 * Check if a given object implements the ReferentialDto interface.
 */
export function instanceOfReferentialDto(value: object): value is ReferentialDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ReferentialDtoFromJSON(json: any): ReferentialDto {
    return ReferentialDtoFromJSONTyped(json, false);
}

export function ReferentialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentialDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function ReferentialDtoToJSON(json: any): ReferentialDto {
    return ReferentialDtoToJSONTyped(json, false);
}

export function ReferentialDtoToJSONTyped(value?: ReferentialDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'iconKey': value['iconKey'],
        'color': value['color'],
    };
}

